import { IEquipmentWithoutProduct } from '@models/Equipment.model';

export interface IProductValue {
  model: string | null | undefined;
  name: string | null | undefined;
  manufacturerName: string | null | undefined;
  manufacturerId: string | null | undefined;
  productId: string | null | undefined;
}

export function getProductValue(
  equipment: IEquipmentWithoutProduct | undefined,
): IProductValue {
  let model: null | string | undefined;
  let name: null | string | undefined;
  let manufacturerName: null | string | undefined;
  let manufacturerId: null | string | undefined;
  let productId: null | string | undefined;

  if (!equipment) {
    return { model, name, manufacturerName, manufacturerId, productId };
  }

  productId = equipment.productId;

  // Stub with imported fields
  if (equipment.importedManufacturerName) {
    manufacturerName = equipment.importedManufacturerName;
  }
  if (equipment.importedName) name = equipment.importedName;
  if (equipment.importedModel) model = equipment.importedModel;

  // Fallback to actual
  if (equipment.product) {
    model = equipment.product.model;
    name = equipment.product.name;
    manufacturerName = equipment.product.manufacturer.name;
    manufacturerId = equipment.product.manufacturer.id;
  }

  return { model, name, manufacturerName, manufacturerId, productId };
}
